<template>
  <v-container>
    <v-row class="text-center" v-if="!login">
      <v-col cols="12"> </v-col>
      <div class="ma-auto position-relative" style="max-width: 300px">
        <v-otp-input
          v-model="otp"
          :disabled="loading"
          @finish="onFinish"
        ></v-otp-input>
        <v-overlay absolute :value="loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-overlay>
      </div>
      <div></div>
    </v-row>

    <v-row class="text-center" v-if="login">
      <v-col cols="12"> </v-col>
      <v-expansion-panels>
        <v-expansion-panel v-for="(ospite, i) in ospiti" :key="i">
          <v-expansion-panel-header>
            <b>{{ ospite.COGNOME }}, {{ ospite.NOME }}</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <b>CITTADINANZA: </b>{{ ospite.CITTADINANZA }}<br />
            <b>LUOGONASCITA:</b> {{ ospite.LUOGONASCITA }}<br />
            <b>DATANASCITA:</b> {{ ospite.DATANASCITA }}<br />
            <b>SESSO:</b> {{ ospite.SESSO }}<br />
            <b>DOCUMENTOTIPO:</b> {{ ospite.DOCUMENTOTIPO }}<br />
            <b>DOCUMENTONUMERO: </b> {{ ospite.DOCUMENTONUMERO }}<br />
            <b>LUOGORILASCIO:</b> {{ ospite.LUOGORILASCIO }}<br />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Verifica",
  components: {},
  data: () => ({
    ospiti: [],
    login: false,
    loading: false,
    snackbar: false,
    snackbarColor: "default",
    otp: "",
    text: "",
    expectedOtp: "030356",
  }),
  mounted() {},
  computed: {
    //riepilogo() {
    //  return this.$store.state.riepilogo;
    //},
  },
  methods: {
    onFinish(rsp) {
      if (rsp === this.expectedOtp) {
        this.datiPrenotazioni();
        this.login = true;
      } else {
        this.otp = "";
      }
    },
    datiPrenotazioni() {
      axios
        .get(`https://api.digisistemi.it/suite23/checkGuest/`)
        .then((response) => {
          this.ospiti = response.data;
        })
        .catch((e) => {
          alert(e);
        });
    },
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}
</style>
